import { Link } from "react-router-dom";
import { getSearchPivotLink } from "../../../samples/util";
import { SEARCH_FIELDS } from "../../mappings";

type Props = {
  className?: string;
  value: string;
  keyword: keyof typeof SEARCH_FIELDS;
};

const SearchLink = ({ className, value, keyword }: Props) => {
  const to = getSearchPivotLink(
    `${SEARCH_FIELDS[keyword]}"${encodeURIComponent(value)}"`
  );
  return (
    <Link to={to} className={className}>
      {value}
    </Link>
  );
};

export default SearchLink;
